var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("Chowly Integration")]),_c('div',{staticClass:"body-2"},[_vm._v("You can sync menu to third party platforms via Chowly at anytime.")]),_c('List',{staticClass:"my-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }